import { Link } from "@tanstack/react-router";
import { Search, CornerDownLeft } from "lucide-react";
import type { Hit } from "./SearchIndex";

export function SearchResults({
  results,
  activeIdx,
  setActiveIdx,
  onSelect,
  query,
  className,
}: {
  results: Hit[];
  activeIdx: number;
  setActiveIdx: (i: number) => void;
  onSelect: () => void;
  query: string;
  className?: string;
}) {
  if (!query.trim()) return null;
  if (results.length === 0) {
    return (
      <div
        className={
          "rounded-xl border border-border bg-white px-5 py-4 text-base text-muted-foreground shadow-lg " +
          (className ?? "")
        }
      >
        No results for "{query.trim()}".
      </div>
    );
  }
  return (
    <div
      className={
        "overflow-hidden rounded-xl border border-border bg-white shadow-xl " +
        (className ?? "")
      }
    >
      <ul className="max-h-[55vh] overflow-y-auto p-2">
        {results.map((h, i) => (
          <li key={`${h.to}-${h.params?.slug ?? ""}-${h.title}`}>
            <Link
              to={h.to as never}
              params={h.params as never}
              data-hit-idx={i}
              onMouseEnter={() => setActiveIdx(i)}
              onClick={onSelect}
              className={`flex items-start gap-3 rounded-xl px-4 py-3 transition ${
                i === activeIdx ? "bg-primary/10" : "hover:bg-primary/5"
              }`}
            >
              <div className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary">
                <Search className="h-3.5 w-3.5" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="truncate text-base font-semibold text-primary">{h.title}</p>
                  <span className="rounded-full bg-accent/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-gold">
                    {h.group}
                  </span>
                </div>
                {h.description && (
                  <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-muted-foreground">
                    {h.description}
                  </p>
                )}
              </div>
              {i === activeIdx && (
                <CornerDownLeft className="mt-1 h-3.5 w-3.5 shrink-0 text-primary/60" />
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
